export const usersList = "USERS_LIST";
export const roleList = "ROLE_LIST";
